export enum PaymentSchedule {
  Yearly = 'yearly',
  Monthly = 'monthly',
}

export enum PaymentFrequencyOptions {
  Monthly = 'M',
  OneOff = 'O',
}

export enum PaymentMethodOptions {
  CreditCard = 'card',
  BankAccount = 'bank',
}

export enum CreditCardType {
  Visa = 'VS',
  MasterCard = 'MC',
  Amex = 'AM',
}

export enum PaymentErrorCode {
  F1 = 'F1',
  MS1 = 'MS1',
  PAYMENT_ERROR_RETRY = 'PAYMENT_ERROR_RETRY',
  PAYMENT_ERROR_SYSTEM = 'PAYMENT_ERROR_SYSTEM',
  /** @todo will be handled post MVP */
  PAYMENT_ERROR_FAILED = 'PAYMENT_ERROR_FAILED',
  UNKNOWN = 'UNKNOWN',
}
